import abi from "./contract/GlobalPool.json";
import abi1 from "./contract/contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";




function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });

      const [state1, setState1] = useState({
    provider: null,
    signer: null,
    contract1: null,
  });

  
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[wlevel,setLevelw]=useState("None");
  const[level1,setLevel1]=useState("None");
  const[wlevel1,setLevelw1]=useState("None");
  const[plevel,setLevelp]=useState("None");
  const[pack,setpackage]=useState("None");
  const[pack3,setpackage3]=useState("None");
  const[pack1,setpackage1]=useState("None");
  const[refer,setrefer]=useState("None");
  const[refer4,setrefer4]=useState("None");
  const[refer3,setrefer3]=useState("None");
  const[refer1,setrefer1]=useState("None");
  const[refer2,setrefer2]=useState("None");
const [tasks,setTasks] = useState([]);
const [tasks1,setTasks1] = useState([]);
const [tt,settt]=useState("None");
const [tt4,settt4]=useState("None");
const[dd,setDD]=useState("None");
const[dd1,setDD1]=useState("None");
const[dd2,setDD2]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[upd,setupd]=useState("None");
const [tt1,settt1]=useState("None");
const [roi,seroi]=useState("None");
const [roi1,seroi1]=useState("None");
const [roi2,seroi2]=useState("None");
const [a1,sea1]=useState("None");
const [a2,sea2]=useState("None");
const [a3,sea3]=useState("None");
const [tt2,settt2]=useState("None");
const [tt3,settt3]=useState("None");
const[b1,setb1]=useState("None");
const[b2,setb2]=useState("None");
const[b3,setb3]=useState("None");
const[b4,setb4]=useState("None");
const[b5,setb5]=useState("None");
const[b6,setb6]=useState("None");
const[b7,setb7]=useState("None");
const[b8,setb8]=useState("None");
const[b9,setb9]=useState("None");
const[b10,setb10]=useState("None");
const[b11,setb11]=useState("None");
const[b12,setb12]=useState("None");
const[b13,setb13]=useState("None");
const[b14,setb14]=useState("None");
const[b15,setb15]=useState("None");
const[b16,setb16]=useState("None");
const[reward,setreward]=useState("None");
const[reward1,setreward1]=useState("None");
const[reward2,setreward2]=useState("None");
const[reward3,setreward3]=useState("None");
const[reward4,setreward4]=useState("None");
const[reward5,setreward5]=useState("None");
const[reward6,setreward6]=useState("None");
const[reward7,setreward7]=useState("None");
const[reward8,setreward8]=useState("None");
const[reward9,setreward9]=useState("None");
const[reward10,setreward10]=useState("None");

const[x1,setx1]=useState("None");
const[x2,setx2]=useState("None");
const[x3,setx3]=useState("None");
const[x4,setx4]=useState("None");
const[x5,setx5]=useState("None");

  useEffect(() => {
    
    const connectWallet = async () => {
      
      const contractAddress = "0xeB7949B072dbb84F4dDA8Aff7b91bfF5353CAcf1";
      const contractABI = abi.abi;
   const contractAddress1 = "0x1f4bb39a2859c25be6884f6990aacf1506d448f3";
      const contract2abi = abi1.abi1;

      const searchParams = new URLSearchParams(window.location.search);
    const myParam = searchParams.get('ref');
    console.log(myParam);
    document.querySelector("#name").value=myParam;
if(myParam == null)
  {
    document.querySelector("#name").value="0xE2767A23D4f40C7F832F1E5C8010C4cCF0D6bB4C";
  }
  
  try {
    const { ethereum } = window;
  //  document.querySelector("#test").value = "0";
    if (ethereum) {
      const account = await ethereum.request({
        method: "eth_requestAccounts",
       
      });
     
      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        
        window.location.reload();
      });
          const provider = new ethers.providers.Web3Provider(ethereum);
        
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
        
        
        
          const signer = provider.getSigner();
     
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );

              const contract1 = new ethers.Contract(
            contractAddress1,
            contract2abi,
            signer
          );

          setAccount(account);
          setState({ provider, signer, contract });
  setState1({ provider, signer, contract1 });     
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      var i = 0;
           document.querySelector("#us").value  = alltasks[13];
      const refer = (alltasks[1]);
      setrefer(refer);
      const a1 = Number(alltasks[0]);
      sea1(a1);
      const refer2 = (alltasks[23]);
     setrefer2(refer2);
	 const x4 = Number(alltasks[22])/1000000000000000000;
     setx4(x4);
      const b =Number(alltasks[2]);
      const x5 = alltasks[13];
     setx5(x5);

     document.querySelector("#hid").value  = (alltasks[1]);
     const direct =Number(alltasks[2]);
     setDirect(direct);
     const level = Number(alltasks[4]);
     setLevel(level);


     const plevel = Number(alltasks[21])/1000000000000000000;
     setLevelp(plevel);
     
    
     const pack = Number(alltasks[3]) ;

setpackage(pack);

document.querySelector("#pp").value  = Number(alltasks[3]);




     setB(b);

     

     const dd = Number(alltasks[9]);
          
     setDD(dd);

     const reward1 = Number(alltasks[11])/1000000000000000000;
          
     setreward1(reward1);
     
     const reward2 = Number(alltasks[17])/1000000000000000000;
          
     setreward2(reward2);
     const reward3 = Number(alltasks[18])/1000000000000000000;
          
     setreward3(reward3);
	   
	 	
								
	
      const reward4 =  Number(alltasks[28]);
      setreward4(reward4);
      const reward5 =  Number(alltasks[27]);
      setreward5(reward5);



      


     const x1 = Number(alltasks[18])/1000000000000000000;
     setx1(x1);
     const x2 = Number(alltasks[21])/1000000000000000000;
     setx2(x2);
     const x3 = Number(alltasks[22])/1000000000000000000;
     setx3(x3);
     
      
       
       const b1 = Number(alltasks[5]) ;
       setb1(b1);
       const b2 = Number(alltasks[6]) ;
       setb2(b2);
       const b3 = Number(alltasks[7]) ;
       setb3(b3);
       const b4 = Number(alltasks[8]) ;
       setb4(b4);
       const b5 = Number(alltasks[9]) ;
       setb5(b5);
       const b6 = Number(alltasks[10]) ;
       setb6(b6);
       const b7 = Number(alltasks[11]) ;
       setb7(b7);
       const b8 = Number(alltasks[12]) ;
       setb8(b8);
       const b9 = Number(alltasks[13])/1000000000000000000 ;
       setb9(b9);
       const b10 = Number(alltasks[14])/1000000000000000000 ;
       setb10(b10);

	   const b11 = Number(alltasks[34])/1000000000000000000 ;
       setb11(b11);
     const wlevel = Number(alltasks[25])/1000000000000000000 ;
          
 setLevelw(wlevel);
 const wlevel1 = Number(alltasks[15])/1000000000000000000;
          
 setLevelw1(wlevel1);
 const level1 = Number(alltasks[24]);
          
 setLevel1(level1);
 

     
    // const a1 = Number(alltasks1[0])-1;
          
    // sea1(a1);
    // const a3 = Number(alltasks1[2])/1000000000000000000;
          
   //  sea3(a3);


const tt =  Number(alltasks[16]);
     settt(tt);
   const a2 = Number(alltasks[24]);
    sea2(a2);   
     var rr = 0;
    // const tt4 =  Number(alltasks[15])/1000000000000000000;
    // settt4(tt4);
     
const pack1 = Number(alltasks[25]);

setpackage1(pack1);

const reward6 =  Number(0);
const reward7 =  ((pack1 + tt)/1000000000000000000).toFixed(0);
      setreward7(reward7);
      document.querySelector("#pending").value  = reward7;
if(reward4 > 499)
{
 if(reward5 > 2499)
{
const reward6 =  Number(166 * 1000000000000000000);
      setreward6(reward6);
const reward7 =  (Number(reward6 + pack1 + tt)/1000000000000000000).toFixed(0);
      setreward7(reward7);
      document.querySelector("#pending").value  = reward7;
} 
}

if(reward4 > 2499)
{
 if(reward5 > 4999)
{
const reward6 =  Number(332 * 1000000000000000000);
      setreward6(reward6);
const reward7 =  (Number(reward6 + pack1 + tt)/1000000000000000000).toFixed(0);
      setreward7(reward7);
      document.querySelector("#pending").value  = reward7;} 
}

if(reward4 > 4999)
{
 if(reward5 > 9999)
{
const reward6 =  Number(664 * 1000000000000000000);
      setreward6(reward6);
const reward7 =  (Number(reward6 + pack1 + tt)/1000000000000000000).toFixed(0);
      setreward7(reward7);
      document.querySelector("#pending").value  = reward7;} 
}

 

     const tt3 = Number(alltasks[10])/1000000000000000000;
     settt3(tt3);


     document.querySelector("#bal").value = tt3;
     const referlink = 'https://aaobanocrorepati.com/?ref='+ account;
     setreflink(referlink);
     document.querySelector("#link").value =referlink;


     const upd = b1+b2+b3+b4+b5+b6+b7+b8+b9+b10+b11+b12+b13+b14+b15;
          
     setupd(upd);


console.log(pack);

  const dd2 = Number(alltasks[31]?.toString?.() || alltasks[30]);
setDD2(dd2);

const dd1 = Math.floor(Date.now() / 1000);
setDD1(dd1);

// remaining seconds (24 hours)
const totalSeconds = Math.max(0, 86400 - (dd1 - dd2));

// convert to hh:mm:ss
const hours = Math.floor(totalSeconds / 3600);
const minutes = Math.floor((totalSeconds % 3600) / 60);
const seconds = totalSeconds % 60;

const formattedTime =
  String(hours).padStart(2, "0") + ":" +
  String(minutes).padStart(2, "0") + ":" +
  String(seconds).padStart(2, "0");

settt2(formattedTime);
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
   
    
    connectWallet();
    
    function myFunction() {
      
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices
      
    
      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }
	document.body.style.backgroundColor = 'black';
  }, []);

 
  // console.log(state);
  return (
  <div>
    <input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
    <input type="hidden" id ="pending"></input>
    <input type="hidden" id ="reward"></input>
    <input type="hidden" id ="packk"></input>
    <input type="hidden" id ="bal"></input>
   
    <section style={{marginTop:"-5rem"}} className="features-section" id="about">
  <div className="section-container">

    <div className="section-header center">
      <div className="badge-pill">BUILT FOR THE NEW ERA</div>
    </div>

    <div className="features-grid">
       {/* Feature 2 */}
      <div className="feature-card">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">Transfer To BVT PRO COIN</span>
         
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-rocket">
            <svg viewBox="0 0 60 60" fill="none">
              <path
                d="M30 12 C30 12 42 22 42 36 L30 46 L18 36 C18 22 30 12 30 12 Z"
                fill="rgba(0,242,254,0.2)"
                stroke="#00f2fe"
                strokeWidth="2"
              />
              <circle cx="30" cy="28" r="4" fill="#00f2fe" />
            </svg>
          </div>
        </div>

       

              <Buy state1={state1} />
        

      </div>
         

     

      {/* Feature 1 */}
      <div className="feature-card gov-card-enriched">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">🏛️ Overview</span>
          <span className="card-mini-tag">● LIVE DAO</span>
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-coin">
            <svg viewBox="0 0 60 60" fill="none">
              <circle
                cx="30"
                cy="30"
                r="22"
                fill="rgba(0,242,254,0.2)"
                stroke="#00f2fe"
                strokeWidth="2"
              />
              <rect
                x="22"
                y="24"
                width="16"
                height="14"
                rx="2"
                fill="#00f2fe"
              />
              <path
                d="M26 24 V20 C26 17.8 27.8 16 30 16 C32.2 16 34 17.8 34 20 V24"
                stroke="#00f2fe"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>

        <h3 className="feature-title">Teams</h3>

        <div className="gov-feature-list">

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span>Direct Team-{direct} </span>
          </div>

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span> Level Team- {level}</span>
          </div>

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
            <span>Team Business- {level1}</span>
          </div>

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            <span> Total Team-{level + direct}</span>
          </div>

        </div>

       

      </div>


      {/* Feature 2 */}
      <div className="feature-card">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">Current Week</span>
         
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-rocket">
            <svg viewBox="0 0 60 60" fill="none">
              <path
                d="M30 12 C30 12 42 22 42 36 L30 46 L18 36 C18 22 30 12 30 12 Z"
                fill="rgba(0,242,254,0.2)"
                stroke="#00f2fe"
                strokeWidth="2"
              />
              <circle cx="30" cy="28" r="4" fill="#00f2fe" />
            </svg>
          </div>
        </div>

        <h3 className="feature-title">Current Week Direct Team</h3>

        <p className="feature-desc">
        {reward4}
        </p>

      </div>
        <div className="feature-card">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">Current Week</span>
         
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-rocket">
            <svg viewBox="0 0 60 60" fill="none">
  <path
    d="M30 8 C30 8 45 17 45 35 L36 43 H24 L15 35 C15 17 30 8 30 8Z"
    fill="rgba(0,242,254,0.15)"
    stroke="#00f2fe"
    strokeWidth="2"
  />
  <circle cx="30" cy="25" r="5"
    fill="#00f2fe"
  />
  <path
    d="M24 43 L20 52 L30 47 L40 52 L36 43"
    fill="rgba(0,242,254,0.2)"
    stroke="#00f2fe"
    strokeWidth="2"
  />
</svg>
          </div>
        </div>

        <h3 className="feature-title">Current Week Team</h3>

        <p className="feature-desc">
        {reward5}  {reward6}<br></br> {reward7}
        </p>


      </div>


     <div className="feature-card gov-card-enriched">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">🏛️ Income</span>
          <span className="card-mini-tag">● LIVE DAO</span>
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-coin">
            <svg viewBox="0 0 60 60" fill="none">
              <circle
                cx="30"
                cy="30"
                r="22"
                fill="rgba(0,242,254,0.2)"
                stroke="#00f2fe"
                strokeWidth="2"
              />
              <rect
                x="22"
                y="24"
                width="16"
                height="14"
                rx="2"
                fill="#00f2fe"
              />
              <path
                d="M26 24 V20 C26 17.8 27.8 16 30 16 C32.2 16 34 17.8 34 20 V24"
                stroke="#00f2fe"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>

        <h3 className="feature-title">Income</h3>

        <div className="gov-feature-list">

          
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span>TOTAL INCOME -{tt + wlevel1} BVTPRO</span>
          </div>
<br></br>

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span> Level Income -{x4} BVTPRO</span>
          </div>
<br></br>
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>Single Leg Income -  {x1} BVTPRO</span>
          </div> 

          <br></br>
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>Salary -  0 BVTPRO</span>
          </div> 

           <br></br>
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>Reward -  0 </span>
          </div> 

        </div>
      </div>


      {/* Feature 3 */}
    

       <div className="feature-card gov-card-enriched">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">🏛️Package</span>
          <span className="card-mini-tag">● LIVE DAO</span>
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-coin">
            <svg viewBox="0 0 60 60" fill="none">
              <circle
                cx="30"
                cy="30"
                r="22"
                fill="rgba(0,242,254,0.2)"
                stroke="#00f2fe"
                strokeWidth="2"
              />
              <rect
                x="22"
                y="24"
                width="16"
                height="14"
                rx="2"
                fill="#00f2fe"
              />
              <path
                d="M26 24 V20 C26 17.8 27.8 16 30 16 C32.2 16 34 17.8 34 20 V24"
                stroke="#00f2fe"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>

        <h3 className="feature-title"> My Package</h3>

        <div className="gov-feature-list">

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span> My Package - {pack} USDT  </span>
          </div>
<br></br>
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span> My Fund value  -  {pack1} BVTPRO</span>
          </div> 
<br></br>
            <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>TOTAL WITHDRAWL - {wlevel1} BVTPRO</span>
          </div> 

        </div>
      </div>

         <div className="feature-card gov-card-enriched">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">🏛️Level Business</span>
          <span className="card-mini-tag">● LIVE DAO</span>
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-coin">
            <svg viewBox="0 0 60 60" fill="none">
              <circle
                cx="30"
                cy="30"
                r="22"
                fill="rgba(0,242,254,0.2)"
                stroke="#00f2fe"
                strokeWidth="2"
              />
              <rect
                x="22"
                y="24"
                width="16"
                height="14"
                rx="2"
                fill="#00f2fe"
              />
              <path
                d="M26 24 V20 C26 17.8 27.8 16 30 16 C32.2 16 34 17.8 34 20 V24"
                stroke="#00f2fe"
                strokeWidth="2"
              />
            </svg>
          </div>
        </div>

        <h3 className="feature-title">Level Business</h3>

        <div className="gov-feature-list">

          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span>   Level 1 Business-  {b1} BVTPRO </span>
          </div>
<br></br>
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>  Level 2 Business  -  {b2} BVTPRO</span>
          </div> 
          <br></br>
          <div className="gov-feature-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>  Level 3 Business  -  {b3} BVTPRO</span>
          </div> 
          <br></br>
         

          
                  </div>
      </div>

       {/* Feature 3 */}
      <div className="feature-card">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">Account</span>
          
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-dao">

            <svg viewBox="0 0 60 60" fill="none">
              <defs>
                <linearGradient id="feat-grad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#00f2fe" />
                  <stop offset="100%" stopColor="#00a8ff" />
                </linearGradient>
              </defs>

              <circle
                cx="30"
                cy="30"
                r="20"
                stroke="url(#feat-grad)"
                strokeWidth="2"
                fill="rgba(0,242,254,0.15)"
              />

              <text
                x="30"
                y="35"
                textAnchor="middle"
                fill="#00f2fe"
                fontFamily="'Orbitron', sans-serif"
                fontWeight="700"
                fontSize="11"
              >
                DAO
              </text>
            </svg>

          </div>
        </div>

        <h3 className="feature-title">My account</h3>

        <p  style={{ fontSize: "8px", wordBreak:"break-all" }} className="feature-desc">
          {account}
        </p>

        

      </div>
       {/* Feature 3 */}
      <div className="feature-card">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">Referal </span>
          
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-dao">

            <svg viewBox="0 0 60 60" fill="none">
              <defs>
                <linearGradient id="feat-grad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#00f2fe" />
                  <stop offset="100%" stopColor="#00a8ff" />
                </linearGradient>
              </defs>

              <circle
                cx="30"
                cy="30"
                r="20"
                stroke="url(#feat-grad)"
                strokeWidth="2"
                fill="rgba(0,242,254,0.15)"
              />

              <text
                x="30"
                y="35"
                textAnchor="middle"
                fill="#00f2fe"
                fontFamily="'Orbitron', sans-serif"
                fontWeight="700"
                fontSize="11"
              >
                DAO
              </text>
            </svg>

          </div>
        </div>

        <h3 className="feature-title">My Refer</h3>

        <p className="feature-desc">
         {refer} 
        </p>

        

      </div>

       <div className="feature-card">

        <div className="feat-top-bar">
          <span className="feat-cat-tag">Referlink</span>
          
        </div>

        <div className="eco-3d-pedestal">
          <div className="eco-icon-dao">

            <svg viewBox="0 0 60 60" fill="none">
              <defs>
                <linearGradient id="feat-grad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#00f2fe" />
                  <stop offset="100%" stopColor="#00a8ff" />
                </linearGradient>
              </defs>

              <circle
                cx="30"
                cy="30"
                r="20"
                stroke="url(#feat-grad)"
                strokeWidth="2"
                fill="rgba(0,242,254,0.15)"
              />

              <text
                x="30"
                y="35"
                textAnchor="middle"
                fill="#00f2fe"
                fontFamily="'Orbitron', sans-serif"
                fontWeight="700"
                fontSize="11"
              >
                DAO
              </text>
            </svg>

          </div>
        </div>

        <h3 className="feature-title">My Referlink</h3>

        <p className="feature-desc">
         <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "8px",
          background: "#18232f",
          border: "1px solid #2e75cc",
          borderRadius: "8px",
          overflow: "hidden"
        }}
      >
        <input
          type="text"
          readOnly
          value={referlink}
          style={{
            flex: 1,
            minWidth: 0,
            border: "none",
            outline: "none",
            background: "transparent",
            color: "#fff",
            padding: "10px",
            fontSize: "13px"
          }}
        />

        <button
          onClick={() => navigator.clipboard.writeText(referlink)}
          style={{
            border: "none",
            background: "#2eaacc",
            padding: "10px 15px",
            cursor: "pointer",
            color: "#fff",
            fontWeight: "bold"
          }}
        >
          <img src="copy.png" width="15" alt="Copy" />
        </button>
      </div>
        </p>

        

      </div>

      



    </div>
  </div>
</section>

    

   
 
   
  
    
 
</div>  
  );
}

export default App;